<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" :width="computedWidth" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0 title-mobile" primary-title>
          {{ computedTitle }}
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="modeloAtividade.Descricao"
                  label="Descrição"
                  prepend-icon="description"
                  :rules="[rules.required]"
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-tabs
              v-model="tabActive"
              color="grey lighten-3"
              slider-color="grey"
            >
              <v-tab ripple>
                <v-subheader class="px-0 font-weight-bold">Atividade</v-subheader>
              </v-tab>
              <v-tab ripple>
                <v-subheader class="px-0 font-weight-bold">Checklists</v-subheader>
              </v-tab>
              <v-tab-item>
                <v-divider></v-divider>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="modeloAtividade.Atividade"
                      label="Atividade"
                      prepend-icon="description"
                      @keyup.enter="adiciona"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      v-model="modeloAtividade.Responsavel"
                      :items="colaboradores"
                      item-text="Descricao"
                      return-object
                      menu-props="auto"
                      label="Responsável"
                      hide-details
                      prepend-icon="person"
                      class="mb-3"
                      no-data-text="Registro não encontrado."
                      auto-select-first
                      clearable
                      @change="changeResponsavel"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      v-model="modeloAtividade.TipoAtividade"
                      :items="tiposAtividadeAtivo"
                      item-text="Descricao"
                      return-object
                      menu-props="auto"
                      label="Tipo Atividade"
                      hide-details
                      prepend-icon="label_important"
                      class="mb-3"
                      no-data-text="Registro não encontrado."
                      auto-select-first
                      clearable
                      :rules="[rules.required]"
                      @change="changeTipoAtividade"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      v-model="modeloAtividade.Workflow"
                      :items="workflowsAtivo"
                      item-text="Descricao"
                      return-object
                      menu-props="auto"
                      label="Workflow"
                      hide-details
                      prepend-icon="timeline"
                      class="mb-3"
                      no-data-text="Registro não encontrado."
                      auto-select-first
                      clearable
                      @change="changeWorkflow"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      v-model="modeloAtividade.Situacao"
                      :items="situacoesAtividade"
                      item-text="Descricao"
                      return-object
                      menu-props="auto"
                      label="Situação"
                      hide-details
                      prepend-icon="description"
                      class="mb-3"
                      auto-select-first
                      clearable
                      no-data-text="Registro não encontrado."
                      @change="changeSituacao"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      v-model="modeloAtividade.Prioridade"
                      :items="prioridadesAtivo"
                      item-text="Descricao"
                      return-object
                      menu-props="auto"
                      label="Prioridade"
                      hide-details
                      prepend-icon="flag"
                      class="mb-3"
                      auto-select-first
                      clearable
                      no-data-text="Registro não encontrado."
                      @change="changePrioridade"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <SharedTextarea
                      :value="modeloAtividade.Observacoes"
                      @change="v => modeloAtividade.Observacoes = v"
                      label="Observações"
                      hide-details
                      outline
                    />
                  </v-flex>
                </v-layout>
              </v-tab-item>
              <v-tab-item>
                <v-layout wrap>
                  <v-container grid-list-md pa-0>
                    <v-layout column>
                      <!-- Input Checklist -->
                      <v-flex xs12 mx-3>
                        <v-layout
                          row
                          :column="$vuetify.breakpoint.smAndDown"
                          v-if="inputChecklist"
                          pt-3
                        >
                          <!-- <v-flex xs12 md2>
                            <v-text-field
                              v-model="modeloAtividadeChecklist.IdOrdem"
                              label="Ordem"
                              hide-details
                              id="checklist-add-item"
                              prepend-icon="reorder"
                            ></v-text-field>
                          </v-flex> -->
                          <v-flex xs12 md9>
                            <v-text-field
                              v-model="modeloAtividadeChecklist.Descricao"
                              label="Descrição"
                              id="checklist-add-item"
                              prepend-icon="folder"
                              :rules="[rules.required]"
                              @keyup.enter="adicionaChecklist"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md3 class="text-xs-right">
                            <v-tooltip bottom>
                              <v-btn fab flat small @click="cancelaEditaChecklist" slot="activator">
                                <v-icon>close</v-icon>
                              </v-btn>
                              <span>Cancelar</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <v-btn fab dark small color="primary" icon @click="adicionaChecklist" slot="activator">
                                <v-icon>done</v-icon>
                              </v-btn>
                              <span>Salvar</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                        <div class="d-flex text-xs-right mt-2" v-else>
                          <v-tooltip bottom>
                            <v-btn fab dark small color="primary" icon @click="mostraInputChecklist" slot="activator">
                              <v-icon>add</v-icon>
                            </v-btn>
                            <span>Adicionar Checklist</span>
                          </v-tooltip>
                        </div>
                      </v-flex>
                      <v-divider class="mx-3"></v-divider>
                      <!-- Lista Checklists -->
                      <v-flex xs12>
                        <v-list class="checklists" v-if="computedChecklists.length">
                          <template v-for="(checklist, index) in computedChecklists">
                            <v-list-tile :key="checklist.IdChecklist">
                              <v-list-tile-content>
                                <v-list-tile-title>{{ checklist.Descricao }}</v-list-tile-title>
                              </v-list-tile-content>

                              <v-list-tile-action>
                                <div class="d-flex justify-end">
                                  <v-tooltip bottom v-if="checklist.IdChecklist">
                                    <v-btn
                                      icon
                                      flat
                                      small
                                      class="mx-0"
                                      slot="activator"
                                      @click="editaChecklist(checklist)"
                                    >
                                      <v-icon small>edit</v-icon>
                                    </v-btn>
                                    <span>Editar</span>
                                  </v-tooltip>
                                  <v-tooltip bottom>
                                    <v-btn
                                      icon
                                      flat
                                      small
                                      class="mx-0"
                                      slot="activator"
                                      @click="excluiChecklist(checklist)"
                                    >
                                      <v-icon small>delete</v-icon>
                                    </v-btn>
                                    <span>Excluir</span>
                                  </v-tooltip>
                                </div>
                              </v-list-tile-action>
                            </v-list-tile>
                            <v-divider :key="index + checklist.Descricao" class="mx-2"></v-divider>
                          </template>
                        </v-list>
                        <div v-else class="d-flex mt-2">
                          <span class="text-xs-center font-weight-bold">Nenhum checklist adicionado à esse modelo.</span>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-layout>
              </v-tab-item>
            </v-tabs>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ModeloAtividade from '@/domain/modeloAtividade/ModeloAtividade';
import ModeloAtividadeChecklist from '@/domain/modeloAtividade/ModeloAtividadeChecklist';
import SharedTextarea from '@/components/shared/Textarea';

export default {
  name: 'ModalCadastroModeloAtividade',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    modeloAtividade: {
      type: Object,
      default: () => new ModeloAtividade()
    },
    modeloAtividadeChecklist: {
      type: Object,
      default: () => new ModeloAtividadeChecklist()
    }
  },
  components: {
    SharedTextarea
  },
  data() {
    return {
      dialog: false,
      loading: false,
      tabActive: null,
      inputChecklist: false,
      checklistsAdicionar: [],
      rules: {
        required: value => !!value || 'Campo obrigatório.',
      }
    }
  },
  computed: {
    ...mapGetters([
      'tiposAtividadeAtivo',
      'colaboradores',
      'prioridadesAtivo',
      'situacoesAtividade',
      'workflowsAtivo',
      'modeloAtividadeChecklists'
    ]),
    computedTitle() {
      return this.modeloAtividade.IdModeloAtividade ? 'Editar Modelo Atividade' : 'Novo Modelo Atividade';
    },
    computedWidth() {
      return this.$vuetify.breakpoint.smAndDown ? '100%' : '60%';
    },
    computedChecklists() {
      if (this.modeloAtividadeChecklists.length) return this.modeloAtividadeChecklists;
      if (this.checklistsAdicionar.length) return this.checklistsAdicionar;
      return [];
    },
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue) this.inicializaBuscas();
    }
  },
  methods: {
    ...mapActions([
      'addModeloAtividade',
      'addModeloAtividadeChecklist',
      'updateModeloAtividade',
      'updateModeloAtividadeChecklist',
      'fetchTiposAtividade',
      'fetchColaboradores',
      'fetchPrioridades',
      'fetchSituacoesAtividade',
      'fetchWorkflows',
    ]),
    ...mapMutations(['showNotification', 'closeNotification']),
    inicializaBuscas() {
      if (!this.tiposAtividadeAtivo.length) this.fetchTiposAtividade();
      if (!this.colaboradores.length) this.fetchColaboradores();
      if (!this.prioridadesAtivo.length) this.fetchPrioridades();
      if (!this.situacoesAtividade.length) this.fetchSituacoesAtividade();
      if (!this.workflowsAtivo.length) this.fetchWorkflows();
    },
    changeTipoAtividade(obj) {
      if (obj && typeof obj === 'object') {
        this.modeloAtividade.IdTipoAtividade = obj.IdTipoAtividade;
        this.modeloAtividade.TipoAtividade = obj.Descricao;
      } else {
        this.modeloAtividade.IdTipoAtividade = undefined;
        this.modeloAtividade.TipoAtividade = '';
      }
    },
    changeResponsavel(obj) {
      if (obj && typeof obj === 'object') {
        this.modeloAtividade.IdResponsavel = obj.IdColaborador;
        this.modeloAtividade.Responsavel = obj.Descricao;
      } else {
        this.modeloAtividade.IdResponsavel = undefined;
        this.modeloAtividade.Responsavel = '';
      }
    },
    changePrioridade(obj) {
      if (obj && typeof obj === 'object') {
        this.modeloAtividade.IdPrioridade = obj.IdPrioridade;
        this.modeloAtividade.Prioridade = obj.Descricao;
      } else {
        this.modeloAtividade.IdPrioridade = undefined;
        this.modeloAtividade.Prioridade = '';
      }
    },
    changeSituacao(obj) {
      if (obj && typeof obj === 'object') {
        this.modeloAtividade.IdSituacao = obj.IdSituacao;
        this.modeloAtividade.Situacao = obj.Descricao;
      } else {
        this.modeloAtividade.IdSituacao = undefined;
        this.modeloAtividade.Situacao = '';
      }
    },
    changeWorkflow(obj) {
      if (obj && typeof obj === 'object') {
        this.modeloAtividade.IdWorkflow = obj.IdWorkflow;
        this.modeloAtividade.Workflow = obj.Descricao;
      } else {
        this.modeloAtividade.IdWorkflow = undefined;
        this.modeloAtividade.Workflow = '';
      }
    },
    async adicionaChecklistsPendentes(idModeloAtividade) {
      if (this.checklistsAdicionar.length) {
        for (const checklist of this.checklistsAdicionar) {
          checklist.IdModeloAtividade = idModeloAtividade;
          await this.addModeloAtividadeChecklist(checklist);
        }
        this.checklistsAdicionar = [];
      } else {
        return;
      }
    },
    async adicionaChecklist() {
      if (!this.modeloAtividadeChecklist.IdChecklist && this.modeloAtividadeChecklist.Descricao) {
        const newChecklist = Object.assign({}, this.modeloAtividadeChecklist);

        // Verifica se o modelo atividade já está cadastrado
        if (this.modeloAtividade.IdModeloAtividade) {
          newChecklist.IdModeloAtividade = this.modeloAtividade.IdModeloAtividade;
        } else {
          this.checklistsAdicionar.push(newChecklist);
          this.$nextTick(() => document.getElementById('checklist-add-item').focus());
          return this.$emit('modeloAtividadeChecklistAdicionado');
        }

        try {
          this.loading = true;
          await this.addModeloAtividadeChecklist(newChecklist);
          this.$emit('modeloAtividadeChecklistAdicionado');
          this.showNotification({ text: 'Checklist adicionado com sucesso.', status: 'success' });
          this.$nextTick(() => document.getElementById('checklist-add-item').focus());
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.showNotification({ text: `Ocorreu um erro ao adicionar o checklist: ${error}.`, status: 'error' });
        }
      } else if (this.modeloAtividadeChecklist.IdChecklist && this.modeloAtividadeChecklist.Descricao) {
        this.loading = true;
        const updChecklist = Object.assign({}, this.modeloAtividadeChecklist);
        try {
          await this.updateModeloAtividadeChecklist(updChecklist);
          this.loading = false;
          this.$emit('modeloAtividadeChecklistAdicionado');
          this.showNotification({ text: 'Checklist atualizado com sucesso.', status: 'success' });
          this.inputChecklist = false;
        } catch (error) {
          this.loading = false;
          this.showNotification({ text: `Ocorreu um erro ao atualizar o email: ${error}.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Informe a descrição.', status: 'error' });
      }
    },
    editaChecklist(checklist) {
      this.$emit('editaChecklist', checklist);
      this.inputChecklist = true;
      this.$nextTick(() => document.getElementById('checklist-add-item').focus());
    },
    excluiChecklist(checklist) {
      if (checklist.IdChecklist) {
        this.$emit('deleteChecklist', checklist);
      } else {
        this.checklistsAdicionar = this.checklistsAdicionar.filter(ca => ca.Descricao !== checklist.Descricao);
      }
    },
    cancelaEditaChecklist() {
      this.inputChecklist = false;
      this.$emit('modeloAtividadeChecklistAdicionado');
    },
    mostraInputChecklist() {
      this.inputChecklist = true;
      this.$nextTick(() => document.getElementById('checklist-add-item').focus());
    },
    async adiciona() {
      if (!this.modeloAtividade.IdModeloAtividade && this.modeloAtividade.Descricao) {
        this.loading = true;
        const newModeloAtividade = Object.assign({}, this.modeloAtividade);
        try {
          const id = await this.addModeloAtividade(newModeloAtividade);
          await this.adicionaChecklistsPendentes(id);
          this.showNotification({ text: `Modelo Atividade: ${newModeloAtividade.Descricao} adicionado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('modeloAtividadeAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao adicionar o modelo atividade: ${error}.`, status: 'error' });
        }
      } else if (this.modeloAtividade.IdModeloAtividade && this.modeloAtividade.Descricao) {
        this.loading = true;
        const updModeloAtividade = Object.assign({}, this.modeloAtividade);
        try {
          await this.updateModeloAtividade(updModeloAtividade);
          this.showNotification({ text: `Modelo Atividade: ${updModeloAtividade.Descricao} atualizado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('modeloAtividadeAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao atualizar o modelo atividade: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe a Descrição do modelo atividade.`, status: 'error' });
      }
    }
  },
}
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1.125rem !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.checklists {
  width: 100%;
}
</style>
